import { useState } from "react";

import { IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, ListSubheader } from "@material-ui/core";

import PhoneIcon from '@material-ui/icons/Phone';
import AddIcon from '@material-ui/icons/Add';
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

import { InputChangeEvent, PhoneInput, PhoneNumberAsYouTypeProps } from "..";

export interface PhoneNumbersPickerProps {
  value: string[];
  onChange: (v: string[]) => void;
}

export function PhoneNumbersPicker(props: PhoneNumbersPickerProps) {
  const { value, onChange } = props;

  const [currentPhone, setCurrentPhone] = useState<string | undefined>();
  const [isCurrentPhoneValid, setIsCurrentPhoneValid] = useState(false);

  const triggerSetPhoneValue = (
    evt: InputChangeEvent, currentPhoneValueProps: Partial<PhoneNumberAsYouTypeProps>
    ) => {
    setIsCurrentPhoneValid(currentPhoneValueProps.valid ?? false);
    setCurrentPhone(evt.target.value);
  }

  const triggerAddPhoneNumber = () => {
    if (currentPhone && isCurrentPhoneValid) {
      setCurrentPhone('');
      setIsCurrentPhoneValid(false);
      onChange(
        [...value, currentPhone]
      );
    }
  }

  const triggerDeleteValue = (idx: number) => {
    const valueCopy = [...value];
    valueCopy.splice(idx, 1);

    onChange([...valueCopy]);
  }

  return (
    <List
      style={{width: '100%'}}
      subheader={
        <ListSubheader>
          Numeri di telefono
        </ListSubheader>
      }
    >
      {value.map((phoneNumber, k) => (
        <ListItem key={k}>
          <ListItemIcon>
            <PhoneIcon />
          </ListItemIcon>
          <ListItemText primary={phoneNumber} />
          <ListItemSecondaryAction>
            <IconButton
              onClick={() => triggerDeleteValue(k)}
            >
              <DeleteForeverIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
      <ListItem>
        <PhoneInput 
          style={{width: '100%'}}
          variant='outlined' 
          defaultValue={currentPhone} 
          onChange={triggerSetPhoneValue}
          InputProps={{
            endAdornment: (
              <IconButton 
                disabled={!isCurrentPhoneValid}
                onClick={triggerAddPhoneNumber}
              >
                <AddIcon />
              </IconButton>
            )
          }}
        />
      </ListItem>
    </List>
  )
}